import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Input,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardFooter,
    UncontrolledTooltip
} from 'reactstrap'

import { Link } from 'react-router-dom'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [catalogs, setCatalogs] = useState([])
    const [filteredData, setFilteredData] = useState([])

    useEffect(() => {
        (async function fetchData() {
            await fetchCatalogs()
        })()

        async function fetchCatalogs() {
            setLoading(true)
            const response = await ApiService.getCatalogs()

            setCatalogs(response.data.catalogs)
            setFilteredData(response.data.catalogs)
            setLoading(false)
        }
    }, []) // eslint-disable-line

    const _filterData = async (e) => {
        const keystroke = e.target.value.toLowerCase()
        const filteredData = catalogs.filter((item) => {
            const name = item.name || ''
            const description = item.description || ''
            const season = item.season || ''
            const supplier = item.supplier.nombreComercial || ''

            return name.toLowerCase().includes(keystroke) ||
                description.toLowerCase().includes(keystroke) ||
                supplier.toLowerCase().includes(keystroke) ||
                season.toLowerCase().includes(keystroke)
        })

        setFilteredData(filteredData)
    }

    return(
        <React.Fragment>
            <Row className="mb-2">
                <Col sm="4">
                    <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative">
                            <Input type="text" className="form-control"
                                placeholder="Buscar catálogos..."
                                onKeyUp={(e) => _filterData(e)}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                {filteredData.map(
                    (item, key) => (
                        <Col key={key} sm={3}>
                            <Card>
                                <Link to={`/catalogos/detalles/${item.slug}`}>
                                    <CardBody style={{ color: 'black' }}>
                                        <CardTitle>{item.name} | {item.supplier.nombreComercial}</CardTitle>
                                        <CardSubtitle>{item.season}</CardSubtitle>
                                        <div className="product-img position-relative">
                                            <img src={`https://storage.googleapis.com/vendora-storage/catalogs/${item.image}`} alt="" className="img-fluid mx-auto d-block" />
                                        </div>
                                    </CardBody>
                                </Link>

                                <CardFooter className="bg-transparent border-top">
                                    <div className="contact-links d-flex font-size-20">
                                        <div className="flex-fill">
                                            <Link id={'img-1'} to={`/catalogos/detalles/${item.slug}`}>
                                                <i className="mdi mdi-eye"></i> <small>Ver Catálogo</small>

                                                <UncontrolledTooltip placement="top" target={'img-1'}>
                                                    Ver Catálogo
                                                </UncontrolledTooltip>
                                            </Link>
                                        </div>

                                        <div className="flex-fill">
                                            <Link id={'img-2'} to={`/pedidos/agregar/${item.supplierId}/${item.id}`}>
                                                <i className="bx bx-purchase-tag"></i> <small>Hacer Pedido</small>

                                                <UncontrolledTooltip placement="top" target={'img-2'}>
                                                    Hacer Pedido
                                                </UncontrolledTooltip>
                                            </Link>
                                        </div>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                    )
                )}
            </Row>
        </React.Fragment>
    )
}

export default Index